import { sellerProjectsViewRouteFactory } from './index';

export default sellerProjectsViewRouteFactory('/projects/archived/');
